import React from "react";

import { Button as SfhButton } from '@arturpol/style-guide/src/components';

import { Link } from '../../components';

const Button = ({children, ...rest}) => <SfhButton linkAs={Link} type="link" {...rest}>{children}</SfhButton>;
const SecondaryButton = ({children, ...rest}) => <Button kind="outline" color="gray" {...rest}>{children}</Button>

export { Button, SecondaryButton };